import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { Loader2 } from "lucide-react";
import { ReactNode } from "react";

interface FeatureGateProps {
  feature: string;
  children: ReactNode;
  fallback?: ReactNode;
  loadingFallback?: ReactNode;
}

export function FeatureGate({ 
  feature, 
  children, 
  fallback = null,
  loadingFallback = <Loader2 className="h-4 w-4 animate-spin" />
}: FeatureGateProps) {
  const { data: enabled, isLoading } = useFeatureFlag(feature);
  
  if (isLoading) return <>{loadingFallback}</>;
  if (!enabled) return <>{fallback}</>;
  return <>{children}</>;
}

// Inverse gate - shows content when feature is DISABLED
export function FeatureGateInverse({ 
  feature, 
  children 
}: { feature: string; children: ReactNode }) {
  const { data: enabled, isLoading } = useFeatureFlag(feature);
  
  if (isLoading) return null;
  if (enabled) return null;
  return <>{children}</>;
}

// Simple wrapper that just hides content if feature is disabled
export function FeatureVisible({ 
  feature, 
  children 
}: { feature: string; children: ReactNode }) {
  const { data: enabled, isLoading } = useFeatureFlag(feature);
  
  if (isLoading || !enabled) return null;
  return <>{children}</>;
}
